import { types } from "../type";

const initialState = {
  numberOfRules: [],
  dashboardError: "",
  dashboardStatus: 0,
  numberOfUsers: null,
  numberOfLocations: [],
  googleMapArray: null,
  dashboardResponse: "",
  dashboardLoading: false,
  numberOfActiveUsers: [],
  dailyAttendanceLocationWiseGraph: []
};

const dashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.DashboardTypes.DASHBOARD_SET_LOADING:
      return {
        ...state,
        dashboardLoading: payload
      };

    case types.DashboardTypes.DASHBOARD_CLEAR_ERRORS:
      return {
        ...state,
        dashboardError: ""
      };
    case types.DashboardTypes.DASHBOARD_GET_ERRORS:
      return {
        ...state,
        dashboardLoading: false,
        dashboardError: payload.data.message,
        dashboardStatus: payload.status
      };
    case types.DashboardTypes.DASHBOARD_CLEAR_RESULT:
      return {
        ...state,
        dashboardResponse: ""
      };
    case types.DashboardTypes.GET_DAILY_ATT_DASHBOARD:
      return {
        ...state,
        dashboardLoading: false,
        numberOfUsers: payload.numberOfUsers,
        // numberOfActiveUsers: payload.numberOfActiveUsers,
        numberOfLocations: payload.numberOfLocations,
        numberOfRules: payload.numberOfRules,
        totalAwsUsers: payload.totalFaceRegisterToAws,
        dailyAttendanceLocationWiseGraph:
          payload.dailyAttendanceLocationWiseGraph
      };
    case types.DashboardTypes.GET_DAILY_GOOGLE_MAP:
      return {
        ...state,
        dashboardLoading: false,
        googleMapArray: payload.geoData
      };
    case types.DashboardTypes.DASHBOARD_UNMOUNT:
      return {
        ...state,
        numberOfUsers: null,
        numberOfLocations: 0,
        dailyAttendanceLocationWiseGraph: null
      };
    default:
      return state;
  }
};

export default dashboardReducer;
